export enum BulkCreateBookingState {
  IsForm = "IsForm",
  IsFirstPreview = "IsFirstPreview",
  IsPreview = "IsPreview",
  IsFinalCreation = "IsFinalCreation",
}
